'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var RotatingSpinners = require('../RotatingSpinners-7cb208d1.js');
require('../tslib.es6-130a177d.js');
require('styled-components');
require('../Animation/index.js');
require('react');



exports.FullPageSpinner = RotatingSpinners.FullPageSpinner;
exports.InlineSpinner = RotatingSpinners.InlineSpinner;
exports.RotatingSpinner = RotatingSpinners.RotatingSpinner;
Object.defineProperty(exports, 'SpinnerScheme', {
	enumerable: true,
	get: function () {
		return RotatingSpinners.SpinnerScheme;
	}
});
exports.default = RotatingSpinners.SvgSpinner;
//# sourceMappingURL=index.js.map
